import { ResolverTag } from '@ps/web-core-enums';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderFR.scss';

const RegulatoryHeaderFR: React.FC<Props> = ({
  regulatory_header: [
    {
      texts: [{ content }],
      icons: [logoFr, eighteenPlusFr]
    }
  ]
}) => (
  <div className={styles.regulatoryHeader}>
    <ResolverLink resolverTag={ResolverTag.Joueurs}>
      <div className={styles.regulatoryText}>
        <CMSHTML content={content} />
      </div>
    </ResolverLink>
    <div className={styles.regulatoryIcons}>
      <CMSImage className={styles.logoFr} {...logoFr} />
      <CMSImage className={styles.eighteenPlusFr} {...eighteenPlusFr} />
    </div>
  </div>
);

export default RegulatoryHeaderFR;
